import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { adminService } from '../../../services/adminService';
import { extractList } from '../../../services/api';
import Loading from '../../../shared/Loading';
import EmptyState from '../../../shared/EmptyState';
import Badge from '../../../shared/Badge';

const UserDetailPage = () => {
  const { userId } = useParams();
  const [user, setUser] = useState(null);
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      adminService.getUserById(userId),
      adminService.getReports(),
    ]).then(([uRes, rRes]) => {
      setUser(uRes.data);
      setReports(extractList(rRes.data).filter((r) => r.user_id === parseInt(userId)));
    }).catch(() => {
      setReports([]);
    }).finally(() => setLoading(false));
  }, [userId]);

  if (loading) return <Loading />;
  if (!user) return <EmptyState icon="❌" title="User tidak ditemukan" />;

  return (
    <div>
      <div className="admin-detail-card">
        <div className="admin-detail-card__avatar">{user.name.charAt(0)}</div>
        <div>
          <div className="admin-detail-card__name">{user.name}</div>
          <div className="admin-detail-card__email">{user.email}</div>
          <span className="admin-role-tag">{user.role}</span>
          <span style={{ marginLeft: 8 }}><Badge status={user.status} /></span>
        </div>
      </div>

      <h3 className="admin-section-title">Laporan Seragam</h3>

      {reports.length === 0 ? (
        <EmptyState icon="📋" title="Belum ada laporan" />
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Periode</th>
                <th>Total Pcs</th>
                <th>Status</th>
                <th>Submitted</th>
              </tr>
            </thead>
            <tbody>
              {reports.map((r) => (
                <tr key={r.uniform_report_id}>
                  <td>{r.period}</td>
                  <td>{r.total_uniform_received}</td>
                  <td><Badge status={r.report_status} /></td>
                  <td>{r.submitted_at || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default UserDetailPage;
